import SearchHeader from '@/components/public-components/Search-header.vue'
import SuspendedToolbar from '@/components/public-components/Suspended-toolbar.vue'
import NavBar from '@/components/public-components/Nav-bar.vue'

export default (Vue) => {
    Vue.component('SearchHeader', SearchHeader),
        Vue.component('SuspendedToolbar', SuspendedToolbar),
        Vue.component('NavBar', NavBar)
}


// WEBPACK FOOTER //
// ./src/assets/js/components.js